/** Backend `sub_applications.key` values */
export const SUB_APPS = {
  SERVICE_REQUESTS: 'service_requests',
  RAISE_THE_SAIL: 'raise_the_sail',
  RISK_CHECKLIST: 'risk_checklist',
  HOMESITE: 'homesite_inspections',
  RULES_VIOLATION: 'rules_violation',
  HURRICANE: 'hurricane',
  INVENTORY: 'inventory',
  HOME_ADMIN: 'home_admin',
};

export function isAdminUser(user) {
  return user?.role_key && String(user.role_key).toLowerCase() === 'admin';
}

export function userHasSubApp(user, appKey) {
  if (!user || !appKey) return false;
  if (isAdminUser(user)) return true;
  if ((user.apps_full || []).includes(appKey)) return true;
  const prefix = `${appKey}.`;
  return (user.fns || []).some((f) => String(f).startsWith(prefix));
}

export function userHasFn(user, appKey, fnKey) {
  if (!user || !appKey || !fnKey) return false;
  if (isAdminUser(user)) return true;
  if ((user.apps_full || []).includes(appKey)) return true;
  return (user.fns || []).includes(`${appKey}.${fnKey}`);
}

/** HomePage tile `id` -> sub_applications.key */
export const TILE_SUB_APP = {
  'service-requests': SUB_APPS.SERVICE_REQUESTS,
  'raise-the-sail': SUB_APPS.RAISE_THE_SAIL,
  'risk-checklist': SUB_APPS.RISK_CHECKLIST,
  'homesite-inspections': SUB_APPS.HOMESITE,
  'rules-violation': SUB_APPS.RULES_VIOLATION,
  hurricane: SUB_APPS.HURRICANE,
  inventory: SUB_APPS.INVENTORY,
  'home-admin': SUB_APPS.HOME_ADMIN,
};
